import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {unpackId} from 'common/diplomatIdUtil';
import {useDispatch} from 'react-redux';
import MoveDialog from 'features/layout/DialogRoutes/dialogs/MoveDialog';
import {partnersActions} from 'redux/partners';

type Props = {
   data: INav;
   header: string;
   onClose: () => void;
};

const MovePartnerDialog = ({data, header, onClose}: Props) => {
   const dispatch = useDispatch();
   const {id} = unpackId(data.id);

   const handleMove = (parentFolderId: string) => {
      dispatch(
         partnersActions.movePartner([id], parentFolderId, {
            onSuccess: onClose,
            onError: onClose,
         })
      );
   };

   return <MoveDialog data={data} header={header} onConfirm={handleMove} onClose={onClose} />;
};

export default MovePartnerDialog;
